import React from 'react';
import { useNavigate } from 'react-router-dom';
import { cn } from '@/lib/utils';

/**
 * Board or register, for one kind of tooling.
 *
 * They are two lists of two different things — jobs waiting on a plate, and the
 * plates the factory owns — so they are two routes rather than another tab on
 * the StatStrip, which already spends itself filtering the board by status.
 * The switch keeps them one click apart.
 */
export function ViewSwitch({ tooling, current }) {
  const navigate = useNavigate();

  const views = [
    { key: 'board', label: 'Board', path: tooling.boardPath },
    { key: 'register', label: 'Register', path: tooling.registerPath },
  ];

  return (
    <span className="flex items-center gap-0.5 rounded bg-slate-100 p-0.5" role="group"
      aria-label={`${tooling.label} views`}>
      {views.map(view => (
        <button
          key={view.key}
          type="button"
          onClick={() => navigate(view.path)}
          aria-current={current === view.key ? 'page' : undefined}
          data-testid={`view-${view.key}`}
          className={cn(
            'rounded px-2.5 py-1.5 text-[11px] font-medium transition-colors sm:py-0.5',
            current === view.key
              ? 'bg-white text-brand-blue shadow-sm'
              : 'text-slate-500 hover:text-slate-800'
          )}
        >
          {view.label}
        </button>
      ))}
    </span>
  );
}

export default ViewSwitch;
